import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const IMMSeo = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Insurance",
    "name": "İhtiyari Mali Mesuliyet Sigortası",
    "description": "En uygun İMM sigortası tekliflerini anında karşılaştırın. Trafik sigortası limitlerini aşan hasarlar için güvence.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "reviewCount": "450"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "İhtiyari Mali Mesuliyet Sigortası (İMM) Nedir?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "İhtiyari mali mesuliyet sigortası, zorunlu trafik poliçesinin sağladığı güvencelerin kapsamını genişleten bir üründür. Araç sahibinin isteğe bağlı olarak yaptırabileceği İMM, işlevsellik açısından zorunlu trafik sigortasına benzer."
        }
      },
      {
        "@type": "Question",
        "name": "İMM sigortası ne işe yarar?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Zorunlu trafik sigortası limitleri, devlet tarafından belirlenen miktarlarla sınırlıdır. İhtiyari mali mesuliyet sigortası, bu limitleri aşan zararları karşılar. Zorunlu trafik poliçesinin limitlerini aşan zararlar, İMM poliçesinden karşılanır."
        }
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>İhtiyari Mali Mesuliyet (İMM) Sigortası | SigortamOlsun</title>
        <meta name="description" content="İhtiyari Mali Mesuliyet (İMM) sigortası ile trafik sigortası limitlerini aşan hasarlarınızı güvence altına alın. En uygun İMM teklifleri için hemen başvurun." />
        <meta name="keywords" content="imm sigortası, ihtiyari mali mesuliyet, imm teminatı, imm nedir" />
        <link rel="canonical" href="https://sigortamolsun.com/imm" />
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <div className="max-w-5xl mx-auto px-4 py-8 md:py-12">
        {/* Neden SigortamOlsun */}
        <section className="mb-12 bg-gradient-to-br from-blue-50 to-purple-50 -mx-4 p-8">
          <h2 className="text-2xl font-bold mb-6 text-center">Neden SigortamOlsun.com ?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="flex items-center gap-4 mb-3">
                <span role="img" aria-label="hızlı teklif" className="text-3xl">⚡️</span>
                <h3 className="font-semibold">Hızlı Teklif</h3>
              </div>
              <p className="text-gray-600 text-sm">Sigorta uzmanımız en kısa sürede size ulaşacak.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="flex items-center gap-4 mb-3">
                <span role="img" aria-label="uygun fiyat" className="text-3xl">💰</span>
                <h3 className="font-semibold">Uygun Fiyat</h3>
              </div>
              <p className="text-gray-600 text-sm">En uygun İMM teklifini sizin için bulacağız.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="flex items-center gap-4 mb-3">
                <span role="img" aria-label="güvenli ödeme" className="text-3xl">🔒</span>
                <h3 className="font-semibold">Güvende Hissedin</h3>
              </div>
              <p className="text-gray-600 text-sm">İhtiyari Mali Mesuliyet poliçenizi yaptırarak güvende olun.</p>
            </div>
          </div>
        </section>

        {/* İMM Bilgilendirme */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6">İhtiyari Mali Mesuliyet (İMM) Sigortası</h2>
          <div className="prose max-w-none space-y-8">
            <div>
              <h3 className="text-xl font-semibold mb-3">İMM Sigortası Nedir?</h3>
              <p className="text-gray-600">
                İhtiyari mali mesuliyet sigortası, zorunlu trafik poliçesinin sağladığı güvencelerin kapsamını genişleten bir üründür. 
                Araç sahibinin isteğe bağlı olarak yaptırabileceği İMM, üçüncü kişilere veya kamu mallarına verilen her tür zararın 
                teminat altına alınmasını sağlar.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-3">İMM Sigortası Ne İşe Yarar?</h3>
              <p className="text-gray-600">
                Zorunlu trafik sigortası limitleri, devlet tarafından belirlenen miktarlarla sınırlıdır. Ancak bazı kazalarda 
                üçüncü kişilerin maddi ve/veya bedensel kayıplarının karşılanması için bu limitler yetersiz kalabilir. İhtiyari mali 
                mesuliyet sigortası, bu noktada devreye girer. Zorunlu trafik poliçesinin limitlerini aşan zararlar, İMM poliçesinden karşılanır.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-3">İMM Sigortasından Neden Önemlidir?</h3>
              <p className="text-gray-600">
              İhtiyari Mali Mesuliyet (İMM) sigortası, zorunlu trafik sigortası limitlerini aşan üçüncü kişilere verilen zararları karşılayan bir güvencedir. Örneğin, bir trafik kazasında karşı tarafın aracında 700.000 TL’lik bir hasar meydana geldiğini düşünelim. Zorunlu trafik sigortası bu hasarın yalnızca 300.000 TL’sini karşılar. Kalan 400.000 TL’lik tutar ise İMM sigortası tarafından karşılanır ve böylece yüksek maliyetli riskler güvence altına alınmış olur.

Bu tür sigorta, özellikle araç değerlerinin yükseldiği günümüzde, araç sahipleri için kritik bir öneme sahiptir.
              </p>
            </div>
          </div>
        </section>

        {/* SSS */}
        <section className="mb-12 bg-gradient-to-br from-blue-50 to-purple-50 -mx-4 p-8">
          <h2 className="text-2xl font-bold mb-6">Sıkça Sorulan Sorular</h2>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="font-semibold mb-3">Trafik sigortam var, yine de İMM sigortası yaptırmalı mıyım?</h3>
              <p className="text-gray-600 text-sm">
                Trafik sigortanız olsa bile İMM poliçesi yaptırmanız yararınıza olacaktır. Çünkü ciddi bir kaza halinde trafik sigortası 
                poliçenizdeki limitler yetersiz kalabilir. Bu durumda İMM sigortası devreye girerek zorunlu trafik poliçesinin yetersiz 
                kalmasından doğabilecek finansal kayıpları önler.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="font-semibold mb-3">İhtiyari mali mesuliyet sigortası & kasko farkı nedir?</h3>
              <p className="text-gray-600 text-sm">
                İhtiyari mali mesuliyet sigortası, üçüncü kişilere verilen maddi ve bedensel hasarları karşılar. Buna karşılık kasko 
                sigortası, araç sahibinin kendi aracında meydana gelen zararları güvence altına alır.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="font-semibold mb-3">Hasar anında ne yapmalıyım?</h3>
              <p className="text-gray-600 text-sm">
                Poliçe kapsamına giren bir hasar meydana geldiğinde, mümkün olan en kısa sürede sigorta şirketinizin hasar hattını 
                arayarak veya online hasar ihbar sayfası üzerinden bildirimde bulunabilirsiniz. Bildiriminiz doğrultusunda hasar 
                dosyanız oluşturulur ve sizden belirli belgeler talep edilir.
              </p>
            </div>
          </div>
        </section>

        {/* İlgili Sigortalar */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold mb-6">İlgili Sigortalar</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <Link to="/trafik-sigortasi" className="block bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition">
              <h3 className="font-semibold mb-2">Trafik Sigortası</h3>
              <p className="text-gray-600 text-sm">Zorunlu trafik sigortanızı hemen yaptırın.</p>
            </Link>
            <Link to="/kasko" className="block bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition">
              <h3 className="font-semibold mb-2">Kasko Sigortası</h3>
              <p className="text-gray-600 text-sm">Aracınızı kapsamlı güvence altına alın.</p>
            </Link>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default IMMSeo;